import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, RadioGroup, FormControlLabel, MenuItem, Radio } from '@material-ui/core';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const EXISTED = "existed";
const NEW = "new";
class DeptInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deptId: "",
            name: "",
            office: "",
            new_office: "",
            description: "",
            radioValue: EXISTED,
            managers: [],
            btnName: this.btnName(this.props.state)
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
    }
    render() {
        const { title, officeData } = this.props;
        const {
            name,
            office,
            new_office,
            description,
            managers,
            radioValue
        } = this.state;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        const officeInfo = () => {
            if (radioValue === EXISTED) {
                return <TextField
                    required
                    disabled={true}
                    id="attorney"
                    select
                    label="Choose the Existed Office"
                    className="textField"
                    value={office}
                    onChange={e => this.handleSelect(e, "office")}
                    margin="dense"
                    variant="outlined"
                >
                    {officeData.map(option => (
                        <MenuItem key={option.id} value={option.office}>
                            {option.office}
                        </MenuItem>
                    ))}
                </TextField>
            } else if (radioValue === NEW) {
                return <TextField
                    required
                    disabled={true}
                    className="textField"
                    id="office"
                    label="Office"
                    onChange={e => this.handleChange(e, "new_office")}
                    margin="dense"
                    variant="outlined"
                    value={new_office}
                />
            }
        }
        return (
            <Root>
                <div className="title">{title}</div>
                <div className="line"></div>
                <TextField
                    required
                    disabled={true}
                    className="textField"
                    id="name"
                    label="Dept. name"
                    onChange={e => this.handleChange(e, "name")}
                    margin="dense"
                    variant="outlined"
                    value={name}
                />
                <RadioGroup
                    aria-label="Gender"
                    name="gender1"
                    row
                    value={radioValue}
                    onChange={this.handleRadio}
                >
                    <FormControlLabel disabled={true} value={EXISTED} control={<Radio color="primary" />} label="Office List" />
                    <FormControlLabel disabled={true} value={NEW} control={<Radio color="primary" />} label="New Office" />
                </RadioGroup>
                {officeInfo()}
                <TextField
                    className="textField"
                    disabled={this.isDisabled()}
                    id="description"
                    label="Description"
                    multiline
                    rows="7"
                    onChange={e => this.handleChange(e, "description")}
                    margin="dense"
                    variant="outlined"
                    value={description}
                />
                {managers.map((option, index) => (
                    <TextField
                        key={index}
                        disabled={true}
                        className="textField"
                        label={(index + 1) + " Manager"}
                        onChange={e => this.handleChange(e, "name")}
                        margin="dense"
                        variant="outlined"
                        value={option.first_name + " " + option.last_name}
                    />
                ))}
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data, state } = this.props;
        console.log(data);
        if (state !== ADD) {
            this.setState(() => ({
                name: data.name,
                office: data.office,
                description: data.description,
                managers: data.managers,
                deptId: data.id,
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const { data } = this.props;
        const { description } = this.state;
        this.props.handleCreate(data.id, description);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleChange(e, name) {
        const value = e.target.value;
        if (name === "name") {
            if (value.length >= 50) {
                return;
            };
        }
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }
}

export default DeptInfo;